<template>
  <div>
    <div class="col-xs-12">
      <!-- Indicador de carga -->
      <div v-if="$apollo.loading || cargando > 0" class="contenedor-spinner">
        <div class="spinner"></div>
      </div>
      <div class="uca-form">
        <div id="uca-form-content" class="uca-form-content row">
          <div v-if="matriculable && matriculable.convocatoria" class="col-xs-offset-1 col-xs-10">
            <h2 class="form-title">Solicitud de Matrícula en la PAU</h2>
            <h3 class="form-title2">{{matriculable.convocatoria.descripcion}} ({{matriculable.convocatoria.ano.anoacad}})</h3>
            <div class="alert alert-info text-center form-alert" role="alert">
              Comprueba que tus datos son correctos.<br>
              Para cualquier consulta contacta con <a href="mailto:acceso@uca.es">acceso@uca.es</a>
            </div>
            <table class="table table-bordered">
                <tbody>
                  <tr>
                    <th class="active">Documento: </th>
                    <td>
                      {{matriculable.letranif ? `${matriculable.dni}${matriculable.letranif}` : matriculable.dni }}
                    </td>
                  </tr>
                  <tr>
                    <th class="active">{{ matriculable.sexo === 'H' ? 'Alumno:' : 'Alumna:' }} </th>
                    <td>
                      {{ matriculable.apellido1 }} {{ matriculable.apellido2 }}, {{ matriculable.nombre }}
                    </td>
                  </tr>
                  <tr>
                    <th class="active">Fecha de nacimiento: </th>
                    <td>
                      {{ (new Date(matriculable.fechaNacimiento)).toLocaleDateString('es-ES') }}
                    </td>
                  </tr>
                  <tr v-if="matriculable.email">
                    <th class="active">Correo electrónico: </th>
                    <td>
                      {{ matriculable.email }}
                    </td>
                  </tr>
                  <tr v-if="matriculable.telefono">
                    <th class="active">Teléfono móvil: </th>
                    <td>
                      {{ matriculable.telefono }}
                    </td>
                  </tr>
                  <tr>
                    <th class="active">Familia numerosa: </th>
                    <td>
                      {{ matriculable.familianumerosa === '4' ? 'Sí (categoría general)': matriculable.familianumerosa === '5' ? 'Sí (categoría especial)' : 'No' }}
                    </td>
                  </tr>
                  <tr>
                    <th class="active">Discapacidad: </th>
                    <td>
                      {{ matriculable.minusvalido ? 'Sí':'No' }}
                    </td>
                  </tr>
                  <tr>
                    <th class="active">Centro: </th>
                    <td>
                      {{ matriculable.centro.nombre }} ({{matriculable.centro.direccion.localidad.nombre}})
                    </td>
                  </tr>
                  <tr>
                    <th class="active">Vía de acceso: </th>
                    <td>
                      {{ matriculable.tipoAcceso === 'B' ? 'Bachillerato' :  matriculable.tipoAcceso === 'C' ? 'Ciclo Formativo' : 'NO DEFINIDA'}}
                    </td>
                  </tr>
                  <tr v-if="matriculable.tipoAcceso === 'B'">
                    <th class="active">Modalidad: </th>
                    <td>
                      {{ matriculable.modalidadBachillerato ? matriculable.modalidadBachillerato.nombre : 'NO DEFINIDA' }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-if="!matriculable.email || !matriculable.telefono">
                <div class="alert alert-warning form-alert text-center" role="alert">
                  <strong>MUY IMPORTANTE:</strong><br/>
                  Necesario para recibir las comunicaciones.
                </div>
                <div v-if="!matriculable.email" class="form-group row">
                  <label for="email" class="col-xs-5 col-form-label text-right">Correo electrónico:</label>
                  <div class="col-sm-5 col-xs-7 text-left">
                    <input type="text" name="email" id="email" class="form-control" aria-label="Correo electrónico" v-model="email1">
                  </div>
                </div>
                <div v-if="!matriculable.email" class="form-group row">
                  <label for="email2" class="col-xs-5 col-form-label text-right">Confirmar correo:</label>
                  <div class="col-sm-5 col-xs-7 text-left">
                    <input type="text" name="email2" id="email2" class="form-control" aria-label="Confirmar correo" v-model="email2"
                           onpaste="return false;">
                    <div class="rojo">{{aviso_email}}&nbsp;</div>
                  </div>
                </div>
                <hr>
                <div v-if="!matriculable.telefono" class="form-group row">
                  <label for="telefono" class="col-xs-5 col-form-label text-right">Teléfono móvil:</label>
                  <div class="col-sm-5 col-xs-7 text-left">
                    <input type="text" name="telefono" id="telefono" class="form-control" aria-label="Teléfono móvil"
                           v-model="telefono1">
                  </div>
                </div>
                <div v-if="!matriculable.telefono" class="form-group row">
                  <label for="telefono2" class="col-xs-5 col-form-label text-right">Confirmar móvil:</label>
                  <div class="col-sm-5 col-xs-7 text-left">
                    <input type="text" name="telefono2" id="telefono2" class="form-control" aria-label="Confirmar móvil" v-model="telefono2"
                           onpaste="return false;">
                    <div class="rojo">{{aviso_telefono}}&nbsp;</div>
                  </div>
                </div>
              </div>
            <div v-if="!faltan_datos" class="alert alert-warning text-center form-alert" role="alert">
              Selecciona las asignaturas.<br/>
              Ten en cuenta que la matrícula <strong>NO SE PODRÁ MODIFICAR</strong> una vez registrada.
            </div>
            <div v-else class="alert alert-danger text-center form-alert" role="alert">
              FALTAN DATOS. No es posible realizar la automatrícula.<br>
              Contacta con <a href="mailto:acceso@uca.es">acceso@uca.es</a>
            </div>
            <div v-if="matriculable.tipoAcceso === 'B' && matriculable.viaAcceso.length > 1"
                 class="alert text-center form-alert" :class="matriculable.viaUnica ? 'alert-warning': 'alert-danger'" role="alert">
              <input type="checkbox" v-model="matriculable.viaUnica"> Me presento a la Prueba de ACCESO
              <div v-if="!matriculable.viaUnica">ATENCIÓN: La matrícula solo será válida si ya tienes superada la Prueba de ACCESO en otra convocatoria.</div>
            </div>
            <div v-for="via in matriculable.viaAcceso" :key="via.id">
              <div v-if="!faltan_datos && (matriculable.viaAcceso.length === 1 || matriculable.viaUnica && via.codigoviaacceso === 'UNICA' || !matriculable.viaUnica && via.codigoviaacceso !== 'UNICA')">
                <div v-for="par in via.parte" :key="par.id">
                  <div class="subtitulo_contenido">
                    <h4 class="subtitulo">
                        <span class="medium_underline"><i class="fa fa-list-alt"></i>
                        {{ par.descripcion }}</span>
                    </h4>
                  </div>
                  <div v-if="par.minimas === 0" class="alert alert-secondary">
                    Puedes seleccionar hasta {{ par.maximas }} materias.<br>
                    Si alguna de las materias no aparece debes contactar con <a href="mailto:acceso@uca.es">acceso@uca.es</a>
                  </div>
                  <div v-for="gru in par.grupoasignaturas" :key="gru.id">
                    <div v-for="(ele, indice) in gru.elegidas" :key="indice" class="form-group row">
                      <div class="row card">
                        <label :for="`asignatura-${gru.id}-${indice}`"
                               class="col-xs-4 col-form-label text-right">{{ ele.descripcion }}:</label>
                        <div class="col-xs-8 text-left">
                          <select :name="`asignatura-${gru.id}-${indice}`" :id="`asignatura-${gru.id}-${indice}`"
                                  :aria-label="ele.descripcion"
                                  v-model="ele.id" :disabled="gru.asignatura.length === 1" class="form-control">
                            <option value="">Selecciona...</option>
                            <option v-for="asi in gru.asignatura" :key="asi.id" :value="asi.id">{{ asi.nombre }}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--Mensajes referidos a cada parte.-->
                  <div v-if="mensajes[par.id]" class="alert alert-danger">
                    {{ mensajes[par.id] }}
                  </div>
                </div>
              </div>
            </div>
            <!--Mensajes generales-->
            <div v-if="mensajes[0]" class="alert alert-danger">
                {{ mensajes[0] }}
            </div>
          </div>
          <div v-else class="col-xs-offset-1 col-xs-10">
            <h2 class="form-title">Solicitud de Matrícula en la PAU</h2>
            <div v-if="!$apollo.loading" class="alert alert-info text-center form-alert" role="alert">
              No tienes acceso a la automatrícula.<br>
              Para cualquier consulta contacta con <a href="mailto:acceso@uca.es">acceso@uca.es</a>
            </div>
          </div>

          <div class="form-group row">
            <div class="col-md-12 col-sm-12 col-xs-12 text-center">
              <br/>
              <router-link :to="{name: 'menu-entrada'}" class="btn btn-danger" aria-label="Cancelar"><i
                  class="fa fa-times"></i> Cancelar
              </router-link> &nbsp;
              <button class="btn btn-primary" aria-label="" :disabled="!puedo_seguir" @click.prevent="confirmar()">
                <i class="fa fa-forward"></i> Siguiente
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Ventana modal de confirmación -->
      <div v-if="confirmando">
        <div id="confirma-solicitud" class="modal show" tabindex="-1" role="dialog">
          <div class="modal-dialog">
            <div class="modal-content">
              <div id="cabecera-confirmacion" class="modal-header">
                <h4 class="modal-title">
                  Confirmando solicitud de matrícula
                </h4>
              </div>
              <div id="cuerpo-confirmacion" class="modal-body">
                  <div v-for="via in matriculable.viaAcceso" :key="via.id">
                    <template v-if="matriculable.viaUnica && via.codigoviaacceso === 'UNICA' || !matriculable.viaUnica && via.codigoviaacceso !== 'UNICA'">
                      <template v-for="par in via.parte" :key="par.id">
                        <div v-if="par.grupoasignaturas.reduce((n, g) => n + g.elegidas.reduce((m, e) => m + (e.id ? 1 : 0), 0), 0) > 0">
                          <div class="subtitulo_contenido">
                            <h4 class="subtitulo">
                              <span class="medium_underline"><i class="fa fa-list-alt"></i>
                                {{ par.descripcion }}:
                              </span>
                            </h4>
                          </div>
                          <div style="margin: 20px;">
                            <table class="table table-bordered">
                              <tbody>
                                <template v-for="gru in par.grupoasignaturas">
                                  <template v-for="ele in gru.elegidas" :key="ele.id">
                                    <tr v-if="ele.id !== ''">
                                      <th class="active">{{ ele.descripcion }}: </th>
                                      <td>{{ gru.asignatura.find(a => a.id === ele.id)?.nombre }}</td>
                                    </tr>
                                  </template>
                                </template>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </template>
                    </template>
                  </div>
                <div class="alert alert-warning text-center">
                  <span>
                    <i class="fa fa-warning"></i> RECUERDA: La solicitud <strong>NO SE PODRÁ MODIFICAR</strong>, una vez presentada.
                  </span>
                </div>

                <div class="alert alert-info text-center">
                  <span>
                    <i class="fa fa-envelope"></i> Cuando registres la solicitud, recibirás un email como justificante en:<br/>
                    <strong>{{email1 || matriculable.email}}</strong>
                  </span>
                </div>

                <div v-if="errorSolicitud" class="alert alert-danger text-center">
                  <strong>Un error ha impedido continuar. La solicitud no se ha grabado.</strong>
                </div>

                <div v-if="$cookies.get(this.$nombreTokenMaestro)" class="alert alert-danger text-center">
                  <strong>La operación está desactivada en modo simulación.</strong>
                </div>

              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-danger" @click.prevent="errorSolicitud = confirmando = false">
                  <i class="fa fa-close"></i> Cancelar
                </button> &nbsp;
                <button type="button" class="btn btn-success" :class="errorSolicitud ? '': 'intermitente'" :disabled="$apollo.loading || cargando > 0 || errorSolicitud || $cookies.get(this.$nombreTokenMaestro)" @click.prevent="registrar_solicitud">
                  <span v-if="$apollo.loading || cargando > 0"><i class="fa fa-check"></i> Registrando...</span>
                  <span v-else><i class="fa fa-check"></i> Registrar solicitud</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Fin ventana modal -->
    </div>
  </div>
</template>

<script>
import {quitarErrorGeneral} from "@/error";
import gql from "graphql-tag";

export default {
  name: "Matricula",
  props: {
    dni: String,
    sello: Number,
  },
  mounted() {
    quitarErrorGeneral();
  },
  data() {
    return {
      confirmando: false,
      errorSolicitud: false,
      cargando: 0,
      email1: '',
      email2: '',
      telefono1: '',
      telefono2: '',
    }
  },
  apollo: {
    matriculable: {
      query: gql`query matriculable($dni: String!, $sello: Int!) {
        matriculable(sello: $sello, dni: $dni) {
          dni
          letranif
          nombre
          apellido1
          apellido2
          sexo
          centro {
            nombre
            direccion {
              localidad {
                nombre
              }
            }
          }
          convocatoria {
            id
            ano {
              anoacad
            }
            descripcion
          }
          email
          telefono
          familianumerosa
          fechaNacimiento
          minusvalido
          modalidadBachillerato {
            nombre
            asignatura {
              id
            }
          }
          tipoAcceso
          viaAcceso {
            id
            codigoviaacceso
            parte {
              id
              descripcion
              grupoasignaturas {
                id
                nombre
                nombreAm
                minimas
                maximas
                referente
                asignatura {
                  id
                  nombre
                  noshowAutomatriculaModgen
                  idioma
                  asociadaMat {
                    id
                  }
                }
              }
            }
          }
        }
      }`,
      variables() {
        return {
          dni: this.dni,
          sello: this.sello
        }
      },
      result(data) {
        // Preparar y filtrar datos
        data.data.matriculable.viaUnica = (data.data.matriculable.tipoAcceso === 'B');
        data.data.matriculable.viaAcceso.forEach((via) => {
          via.parte.forEach((par) => {
            par.minimas = par.grupoasignaturas.reduce((m, g) => m + g.minimas, 0);
            par.maximas = par.grupoasignaturas.reduce((m, g) => m + g.maximas, 0);
            par.grupoasignaturas.forEach((gru) => {
              if (gru.nombre !== 'PAU_Historia') {
                gru.asignatura = gru.asignatura.filter((asi) => !asi.noshowAutomatriculaModgen);
              }
              // Filtrar asignaturas de modalidad
              if (gru.referente && data.data.matriculable.modalidadBachillerato && data.data.matriculable.modalidadBachillerato.asignatura.length > 0) {
                gru.asignatura = gru.asignatura.filter((asi) => data.data.matriculable.modalidadBachillerato.asignatura.some((a) => a.id === asi.id));
              }
              gru.elegidas = [];
              const nombres = gru.nombreAm.split(',');
              for (let i = 0; i < gru.maximas; i++) {
                gru.elegidas.push({
                  id: gru.asignatura.length === 1 ? gru.asignatura[0].id.toString() : '',
                  descripcion: nombres[i].trim() || gru.nombre,
                });
              }
              // Correspondencias de asignaturas asociadas e idiomas
              gru.asociadas = {};
              gru.idiomas = [];
              gru.asignatura.forEach((asi) => {
                if (asi.asociadaMat) {
                  gru.asociadas[asi.id.toString()] = asi.asociadaMat.id.toString();
                }
                if (asi.idioma) {
                  gru.idiomas.push(asi.id.toString());
                }
              });
            });
          });
        });
      },
      fetchPolicy: 'network-only',
      skip() {
        return !this.dni || this.sello === null;
      },
      error() {
        this.$emit('aviso', 'Ha habido un error. Pruebe más tarde.');
      },
    },
  },
  computed: {
    faltan_datos() {
      return !(this.matriculable && (this.matriculable.tipoAcceso === 'B' && this.matriculable.modalidadBachillerato || this.matriculable.tipoAcceso === 'C'));
    },
    mensajes() {
      // Obtiene los posibles mensajes de error indexados por el ID de las partes.
      // El índice 0 se reserva para los mensajes generales que no se refieren a una parte concreta.
      const mensajes = {};
      if (!this.faltan_datos && this.matriculable.viaAcceso && this.matriculable.viaAcceso.length > 0) {
        this.matriculable.viaAcceso.forEach((via) => {
          if (this.matriculable.viaAcceso.length === 1 || this.matriculable.viaUnica && via.codigoviaacceso === 'UNICA' || !this.matriculable.viaUnica && via.codigoviaacceso !== 'UNICA') {
            for (const par of via.parte) {
              if (par.grupoasignaturas.reduce((m, g) => m + g.elegidas.reduce((n, e) => (e.id ? n + 1 : n), 0), 0) < par.minimas) {
                mensajes[par.id] = 'No has seleccionado todas las materias obligatorias.';
              }
            }
            const ids = [];
            via.parte.forEach((parte) => {
              parte.grupoasignaturas.forEach((grupo) => {
                let idiomas = 0;
                let total = 0;
                grupo.elegidas.forEach((elegida) => {
                  if (elegida.id) { // Ignorar IDs vacíos
                    ids.push(elegida.id);
                    total++;
                    if (grupo.asociadas[elegida.id]) {
                      ids.push(grupo.asociadas[elegida.id]);
                    }
                    if (grupo.idiomas.includes(elegida.id)) {
                      idiomas++;
                    }
                  }
                });
                if (idiomas > 1) {
                  mensajes[parte.id] = 'Solo se puede elegir un idioma en esta parte.';
                }
                if (total === grupo.maximas && grupo.maximas > grupo.minimas && idiomas === 0) {
                  // Si un grupo admite optativas y elige todas, al menos una tiene que ser de idioma
                  mensajes[parte.id] = 'Si seleccionas todas las materias, una debe ser de idioma.';
                }
              });
            });
            if (ids.length === 0) {
              mensajes[0] = 'No has seleccionado ninguna asignatura.';
            }
            if (ids.some((elemento, index) => ids.indexOf(elemento) !== index)) {
              mensajes[0] = 'Hay asignaturas repetidas.';
            }
          }
        });
      }
      return mensajes;
    },
    puedo_seguir() {
      return Object.keys(this.mensajes).length === 0 && !this.aviso_email && !this.aviso_telefono;
    },
    aviso_email() {
      if (this.email1) {
        if (this.email1.trim() === this.email2.trim()) {
          if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email1.trim())) {
            return '';
          } else {
            return 'Formato de correo incorrecto';
          }
        } else {
          return 'Los correos no coinciden';
        }
      } else {
        if (this.matriculable && this.matriculable.email) {
          return '';
        }
        else {
          return 'El correo es obligatorio';
        }
      }
    },
    aviso_telefono() {
      if (this.telefono1) {
        if (this.telefono1.trim() === this.telefono2.trim()) {
          if (/^(\+34)?([67])\d{8}$/.test(this.telefono1.trim())) {
            return '';
          } else {
            return 'Formato de móvil no admitido';
          }
        } else {
          return 'Los números no coinciden';
        }
      }
      else {
        if (this.matriculable && this.matriculable.telefono) {
          return '';
        }
        else {
          return 'El teléfono móvil es obligatorio';
        }
      }
    },
  },
  methods: {
    confirmar() {
      // Reordenar asignaturas para evitar huecos dentro de los grupos
      this.matriculable.viaAcceso.forEach((via) => {
        if (this.matriculable.viaUnica && via.codigoviaacceso === 'UNICA' || !this.matriculable.viaUnica && via.codigoviaacceso !== 'UNICA') {
          via.parte.forEach((par) => {
            par.grupoasignaturas.forEach((gru) => {
              let posicion = -1;
              for (let i = 0; i < gru.elegidas.length; i++) {
                if (gru.elegidas[i].id) {
                  posicion++;
                  if (posicion < i) {
                    // Se mueve el ID, pero se mantiene la descripción
                    gru.elegidas[posicion].id = gru.elegidas[i].id;
                    gru.elegidas[i].id = '';
                  }
                }
              }
            });
          });
        }
      });
      this.confirmando = true;
    },
    registrar_solicitud() {
      // Recopilar asignaturas
      let matriculaVia = {};
      this.matriculable.viaAcceso.forEach((via) => {
        if (this.matriculable.viaUnica && via.codigoviaacceso === 'UNICA' || !this.matriculable.viaUnica && via.codigoviaacceso !== 'UNICA') {
          matriculaVia['viaId'] = via.id;
          matriculaVia['matriculaPartes'] = []
          via.parte.forEach((par) => {
            let p = {
              'parteId': par.id,
              matriculaGrupos: []
            }
            par.grupoasignaturas.forEach((gru) => {
              let g = {
                'grupoId': gru.id,
                matriculaAsignaturas: []
              }
              gru.elegidas.forEach((ele) => {
                if (ele.id) {
                  g.matriculaAsignaturas.push(ele.id);
                }
              });
              p.matriculaGrupos.push(g);
            });
            matriculaVia['matriculaPartes'].push(p);
          });
        }
      });
      this.cargando++;   // El $apollo.loading no funciona cuando se llama directamente con this.$apollo
      this.$apollo.mutate({
        mutation: gql`mutation($dni: String!, $convocatoria: String!, $viaUnica: Boolean!, $matriculaVia: MatriculaViaInput!,
                  $email: String, $telefono: String) {
          matricular(dni: $dni,  convocatoria: $convocatoria, viaUnica: $viaUnica, matriculaVia: $matriculaVia,
                    email: $email, telefono: $telefono) {
            correcto
            recibo
          }
        }`,
        variables: {
          convocatoria: this.matriculable.convocatoria.id,
          dni: this.matriculable.dni,
          viaUnica: this.matriculable.viaUnica,
          matriculaVia: matriculaVia,
          // Si email y teléfono están vacíos se mantendrán los que ya tuviera el alumno
          email: this.email1,
          telefono: this.telefono1,
        },
      }).then((data) => {
        if (data.data.matricular.correcto) {
          this.$emit('completada-matricula', data.data.matricular.recibo, this.situaciones_especiales !== '');
          this.$router.push({name: 'menu-entrada'});
        }
        else {
          this.errorSolicitud = true;
        }
      }).catch((error) => {
        this.errorSolicitud = true;
        console.error(error);
      }).finally(() => {
        this.cargando--;
      });
    }
  }
}
</script>

<style scoped>
#cabecera-confirmacion {
    background-color: #d9edf7;
}

button:disabled,
button[disabled]{
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
}

a:disabled,
a[disabled]{
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
}

div.modal-body ul.sol-ul-add {
    background-color: #d5f5e3;
    list-style-position: inside;
}
</style>